var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scoreTile"},[_c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"red"},[_c('h2',{class:_vm.checkSmallFont},[_vm._v(_vm._s(_vm.point))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }